import React from 'react';
import './DeleteConfirmationDialog.css';

const DeleteConfirmationDialog = ({ visible, description , onCancel, onConfirm, name, loading }) => {
  if (!visible) return null;

  return (
    <div className="delete-dialog-backdrop">
      <div className="delete-dialog">
        <div className="delete-dialog-content">
          <div className="dialog-message">
            
            {description}
          </div>
          <div className="dialog-actions">
            <button className="cancel-button" onClick={onCancel}>
              Cancel
            </button>
            <button className="confirm-button" onClick={onConfirm} disabled={loading}>
              {loading ? 'Archive...' : 'Archive'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationDialog;
